export default __webpack_public_path__ + "maps-examples-image-source-1200-02bce493720fe8107666c24025d05dfd.webp";